/* eslint-disable no-restricted-imports */
import React, { useEffect } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { useBatchContext } from "./BatchDataContext";

export function BatchFullDialog({
  history,
  id,
  show,
  onHide,
  setFullSuccessOpen,
  setFullErrorOpen,
}) {
  const context = useBatchContext();
  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const markBatchFull = async () => {
    const batchFullUrl = "api/batches/full/";
    const result = await axios.patch(batchFullUrl + id);
    if (result.data === "success") {
      console.log("marked batch full");
      setFullSuccessOpen(true);
      context.setRefetch(true);
      setTimeout(() => {
        history.push("/batches/batch-list");
      }, 1000);
    } else {
      console.log(result.data);
      setFullErrorOpen(true);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/* {isLoading && <ModalProgressBar variant="query" />} */}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">Batch Full</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span>Are you sure you want to mark this batch full?</span>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="button"
            onClick={markBatchFull}
            className="btn btn-delete btn-elevate"
          >
            Mark Full
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
